import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, TargetIcon, ActivityIcon, HeartPulseIcon, PlusCircleIcon } from 'lucide-react';
export function AspenDifferenceSection() {
  const features = [{
    icon: ZapIcon,
    title: 'Professional Class IV Laser Technology',
    desc: 'Advanced equipment designed to deliver therapeutic light energy efficiently.'
  }, {
    icon: TargetIcon,
    title: 'Focused Light Energy',
    desc: 'Delivered directly to the treatment area to target the source of discomfort.'
  }, {
    icon: ActivityIcon,
    title: 'Supports Healing at the Cellular Level',
    desc: 'Supports circulation, cellular energy, inflammation response, and tissue repair.'
  }, {
    icon: HeartPulseIcon,
    title: 'Gentle & Non-Invasive',
    desc: 'A comfortable treatment experience without needles, surgery, or medication.'
  }, {
    icon: PlusCircleIcon,
    title: 'Combines With Other Care',
    desc: 'Can be used alongside chiropractic care, massage therapy, decompression, stretching, and strengthening when appropriate.'
  }];
  return <section className="py-20 md:py-24 bg-white" data-id="element-16">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14 max-w-3xl mx-auto" data-id="element-18">
          <div className="inline-block py-1.5 px-4 rounded-full bg-brand-teal/10 text-brand-teal-dark text-xs font-black tracking-widest uppercase mb-5" data-id="element-19">
            Aspen Pinnacle
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-brand-navy mb-5 leading-tight" data-id="element-20">
            What Makes Aspen Pinnacle Laser Therapy Different?
          </h2>
          <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-21">
            Aspen laser therapy uses photobiomodulation to interact with tissue
            at the cellular level — a modern, focused approach to pain support
            and recovery.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-22">
          {features.map((feature, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.08
        }} className={`flex items-start gap-5 p-6 md:p-7 rounded-2xl border-2 border-gray-200 hover:border-brand-teal/40 hover:shadow-md transition-all duration-300 ${idx === features.length - 1 && features.length % 2 !== 0 ? 'md:col-span-2' : ''}`} data-id="element-23">
              <div className="w-14 h-14 bg-brand-teal rounded-xl shadow-md shadow-brand-teal/20 flex items-center justify-center flex-shrink-0 text-white" data-id="element-24">
                <feature.icon className="w-7 h-7" data-id="element-25" />
              </div>
              <div data-id="element-26">
                <h3 className="text-lg md:text-xl font-black text-brand-navy mb-2 leading-tight" data-id="element-27">
                  {feature.title}
                </h3>
                <p className="text-gray-700 leading-relaxed text-sm md:text-base" data-id="element-28">
                  {feature.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}